module.exports = "/images/vendor/flag-icon-css/flags/1x1/gu.svg?64936a10d41e5fb3e672075620a716f0";